/**
 * @generated SignedSource<<b6be539987c51cf540ded76238f706cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Gender = "FEMALE" | "MALE" | "PRIVATE" | "%future added value";
export type Units = "METRIC" | "US" | "%future added value";
export type UpdateUserInput = {
  admin?: boolean | null | undefined;
  birthday?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  displayName?: string | null | undefined;
  gender?: Gender | null | undefined;
  height?: string | null | undefined;
  id: string;
  location?: string | null | undefined;
  passwordUpdated?: boolean | null | undefined;
  phone?: string | null | undefined;
  phoneCode?: string | null | undefined;
  photoURL?: string | null | undefined;
  themeOptions?: string | null | undefined;
  timeZone?: string | null | undefined;
  topToolbar?: boolean | null | undefined;
  trialExpiryDate?: string | null | undefined;
  units?: Units | null | undefined;
  username?: string | null | undefined;
  weight?: string | null | undefined;
};
export type CoachSettingsAccountUpdateMutation$variables = {
  input: UpdateUserInput;
};
export type CoachSettingsAccountUpdateMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"CoachSettingsAccount_user" | "CurrentUserProvider_user">;
    } | null | undefined;
  } | null | undefined;
};
export type CoachSettingsAccountUpdateMutation = {
  response: CoachSettingsAccountUpdateMutation$data;
  variables: CoachSettingsAccountUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSample",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v23 = [
  (v16/*: any*/),
  (v15/*: any*/),
  (v2/*: any*/)
],
v24 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM DD, YYYY"
  }
],
v25 = {
  "alias": "formattedDate",
  "args": (v24/*: any*/),
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": "updatedAt(format:\"MMM DD, YYYY\")"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Group",
  "kind": "LinkedField",
  "name": "group",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachSettingsAccountUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CurrentUserProvider_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CoachSettingsAccount_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoachSettingsAccountUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": "rawEmail",
                "args": (v5/*: any*/),
                "kind": "ScalarField",
                "name": "email",
                "storageKey": "email(raw:true)"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerified",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadMessagesCounter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationsActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationUnreadCount",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "units",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isImpersonating",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "admin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "topToolbar",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientsCount",
                "storageKey": null
              },
              {
                "alias": "clientsCountNoSample",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "noSample",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "clientsCount",
                "storageKey": "clientsCount(noSample:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "programsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadActivitiesCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "kind": "ScalarField",
                "name": "trialExpiryDate",
                "storageKey": "trialExpiryDate(raw:true)"
              },
              {
                "alias": "trialExpiryDateTimestamp",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "X"
                  }
                ],
                "kind": "ScalarField",
                "name": "trialExpiryDate",
                "storageKey": "trialExpiryDate(format:\"X\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trialExpired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "plan",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planTier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "coach",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "accounts",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": "displayName(raw:true)"
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "GroupConnection",
                "kind": "LinkedField",
                "name": "groups",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Group",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v2/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": "groups(first:3)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GroupNavItemList_groups",
                "kind": "LinkedHandle",
                "name": "groups"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientNutritionTarget",
                "kind": "LinkedField",
                "name": "nutritionTarget",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v20/*: any*/),
                "concreteType": "NotificationConnection",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unreadCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Notification",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v2/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activityFeedbackId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActivityFeedback",
                            "kind": "LinkedField",
                            "name": "activityFeedback",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Activity",
                                "kind": "LinkedField",
                                "name": "activity",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Component",
                                    "kind": "LinkedField",
                                    "name": "component",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v22/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Program",
                                        "kind": "LinkedField",
                                        "name": "program",
                                        "plural": false,
                                        "selections": (v23/*: any*/),
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ClientForm",
                                    "kind": "LinkedField",
                                    "name": "clientForm",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v25/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v5/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "date",
                                    "storageKey": "date(raw:true)"
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v26/*: any*/),
                              {
                                "alias": "formattedDate",
                                "args": (v24/*: any*/),
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": "createdAt(format:\"MMM DD, YYYY\")"
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GroupPost",
                            "kind": "LinkedField",
                            "name": "groupPost",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v26/*: any*/),
                              (v22/*: any*/),
                              (v25/*: any*/),
                              (v21/*: any*/),
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "message",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v26/*: any*/),
                              (v25/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "notified",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GroupPostComment",
                            "kind": "LinkedField",
                            "name": "groupComment",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v26/*: any*/),
                              (v25/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GroupPost",
                                "kind": "LinkedField",
                                "name": "groupPost",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v27/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientForm",
                            "kind": "LinkedField",
                            "name": "clientForm",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deleted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "read",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": "notifications(first:10)"
              },
              {
                "alias": null,
                "args": (v20/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "NotificationsMenu_notifications",
                "kind": "LinkedHandle",
                "name": "notifications"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "passwordSet",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v24/*: any*/),
                "kind": "ScalarField",
                "name": "passwordUpdatedAt",
                "storageKey": "passwordUpdatedAt(format:\"MMM DD, YYYY\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationsSetting",
                "kind": "LinkedField",
                "name": "notificationsSetting",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newMessageEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newResponseEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activityCompletion",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ac4f188633078a83b713a44277b9f57",
    "id": null,
    "metadata": {},
    "name": "CoachSettingsAccountUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CoachSettingsAccountUpdateMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      ...CurrentUserProvider_user\n      ...CoachSettingsAccount_user\n      id\n    }\n  }\n}\n\nfragment CoachSettingsAccount_user on User {\n  id\n  displayName\n  email\n  photoURL\n  timeZone\n  passwordSet\n  passwordUpdatedAt(format: \"MMM DD, YYYY\")\n  phone\n  phoneCode\n  phoneVerified\n  units\n  notificationsSetting {\n    id\n    newMessageEmail\n    newResponseEmail\n    activityCompletion\n  }\n}\n\nfragment CurrentUserProvider_user on User {\n  id\n  username\n  email\n  rawEmail: email(raw: true)\n  displayName\n  photoURL\n  phone\n  phoneVerified\n  timeZone\n  unreadMessagesCounter\n  notificationsActive\n  notificationUnreadCount\n  role\n  location\n  birthday\n  age\n  gender\n  units\n  height\n  weight\n  createdAt\n  isSample\n  isImpersonating\n  admin\n  topToolbar\n  clientsCount\n  clientsCountNoSample: clientsCount(noSample: true)\n  programsCount\n  unreadActivitiesCount\n  trialExpiryDate(raw: true)\n  trialExpiryDateTimestamp: trialExpiryDate(format: \"X\")\n  trialExpired\n  plan\n  planTier\n  subscription {\n    status\n    id\n  }\n  coach {\n    username\n    email\n    displayName\n    photoURL\n    id\n  }\n  accounts {\n    id\n    role\n    isSample\n    username\n    email\n    displayName(raw: true)\n    photoURL\n    phone\n    timeZone\n    createdAt\n    ...UserAccountMenuItem_user\n  }\n  groups(first: 3) {\n    totalCount\n  }\n  nutritionTarget {\n    id\n  }\n  ...Notifications_user\n  ...GroupNavItemList_me\n}\n\nfragment GroupNavItemListItem on Group {\n  name\n  slug\n}\n\nfragment GroupNavItemList_me on User {\n  groups(first: 3) {\n    totalCount\n    edges {\n      node {\n        ...GroupNavItemListItem\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment NotificationBox_notification on Notification {\n  id\n  author {\n    username\n    displayName\n    photoURL\n    id\n  }\n  activityFeedbackId\n  activityFeedback {\n    activity {\n      type\n      component {\n        slug\n        title\n        program {\n          slug\n          name\n          id\n        }\n        id\n      }\n      clientForm {\n        name\n        slug\n        formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n        id\n      }\n      date(raw: true)\n      id\n    }\n    content\n    formattedDate: createdAt(format: \"MMM DD, YYYY\")\n    id\n  }\n  groupPost {\n    id\n    content\n    title\n    formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n    author {\n      username\n      displayName\n      photoURL\n      id\n    }\n    group {\n      slug\n      name\n      id\n    }\n  }\n  message {\n    id\n    content\n    formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n    author {\n      username\n      displayName\n      photoURL\n      id\n    }\n    notified\n  }\n  groupComment {\n    id\n    content\n    formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n    author {\n      username\n      displayName\n      photoURL\n      id\n    }\n    groupPost {\n      title\n      group {\n        slug\n        name\n        id\n      }\n      id\n    }\n  }\n  clientForm {\n    id\n    name\n    slug\n    formattedDate: updatedAt(format: \"MMM DD, YYYY\")\n  }\n  deleted\n  read\n}\n\nfragment NotificationsMenu_userRef on User {\n  notifications(first: 10) {\n    edges {\n      node {\n        id\n        ...NotificationBox_notification\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n  }\n  id\n}\n\nfragment Notifications_user on User {\n  id\n  notificationsActive\n  notifications(first: 10) {\n    unreadCount\n    edges {\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...NotificationsMenu_userRef\n}\n\nfragment UserAccountMenuItem_user on User {\n  id\n  role\n  displayName(raw: true)\n  isSample\n  photoURL\n}\n"
  }
};
})();

(node as any).hash = "a7d801c5ee48905a85caeb2fadfc1c0f";

export default node;
